<app-header *ngIf="loggedUser && !loggedUser.originalPassword"></app-header>
<app-sidenav *ngIf="loggedUser && !loggedUser.originalPassword"></app-sidenav>
<div class="offline-alert-wrapper" *ngIf="!isOnline">
  <div class="offline-alert">
    {{ 'common.errors.you_are_offline' | translate }}
  </div>
</div>
<div class="change-role-alert-wrapper" *ngIf="isRoleChanging">
  <div class="change-role-alert">
    {{ 'common.warnings.role_is_changing' | translate }}
  </div>
</div>
<app-card-spinner [visible]="!loggedUser || (loggedUser && loggedUser.originalPassword)" type="zero"></app-card-spinner>